/* era-embla.js — turn the ingredients (and later, comparison) into Embla swipe carousels.
   Embla is already loaded by the Erawell theme (window.EmblaCarousel). Fallback-safe. */
(function () {
  function ready(){ return typeof window.EmblaCarousel !== 'undefined'; }
  function injectCss(){
    if (document.getElementById('era-embla-css')) return;
    var css =
      '.era-embla{position:relative;}' +
      '.era-embla__vp{overflow:hidden;}' +
      '.era-embla__ct{display:flex;backface-visibility:hidden;touch-action:pan-y;gap:14px;}' +
      '.era-embla__slide{flex:0 0 84%;min-width:0;}' +
      '@media(min-width:750px){.era-embla__slide{flex:0 0 31.5%;}}' +
      '.era-embla__dots{display:flex;justify-content:center;align-items:center;gap:8px;margin-top:18px;}' +
      '.era-embla__dot{appearance:none;-webkit-appearance:none;border:0;padding:0;margin:0;cursor:pointer;width:8px;height:8px;border-radius:50%;background:rgba(45,139,139,.28);transition:width .25s,background .25s;}' +
      '.era-embla__dot.is-on{width:22px;border-radius:5px;background:#2d8b8b;}' +
      /* comparison cards */
      '.era-cmp-card{background:#fff;border:1px solid #e4ecf0;border-radius:14px;padding:22px 18px;box-shadow:0 2px 10px rgba(13,27,46,.05);height:100%;box-sizing:border-box;}' +
      '.era-cmp-card__feat{font-weight:700;font-size:15px;color:#0d1b2e;text-align:center;margin-bottom:16px;min-height:42px;display:flex;align-items:center;justify-content:center;line-height:1.3;}' +
      '.era-cmp-card__grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;}' +
      '.era-cmp-card__col{text-align:center;padding:14px 8px;border-radius:10px;background:#f6f8f9;}' +
      '.era-cmp-card__col.is-hero{background:#e4f4f9;border:1px solid #bfe3ec;}' +
      '.era-cmp-card__icon{display:flex;justify-content:center;margin-bottom:8px;min-height:26px;}' +
      '.era-cmp-card__icon svg{width:26px;height:26px;}' +
      '.era-cmp-card__lbl{font-size:12px;font-weight:600;color:#5a6b7a;line-height:1.2;}' +
      '.era-cmp-card__col.is-hero .era-cmp-card__lbl{color:#0d1b2e;}';
    var s=document.createElement('style'); s.id='era-embla-css'; s.textContent=css; document.head.appendChild(s);
  }
  function build(host, slides, opts){
    if (!slides.length || host.__emblaDone) return;
    host.__emblaDone = true;
    var vp=document.createElement('div'); vp.className='era-embla__vp';
    var ct=document.createElement('div'); ct.className='era-embla__ct';
    slides.forEach(function(sl){ sl.classList.add('era-embla__slide'); ct.appendChild(sl); });
    vp.appendChild(ct);
    host.classList.add('era-embla');
    host.appendChild(vp);
    var embla;
    try { embla=window.EmblaCarousel(vp, Object.assign({loop:true, align:'center', containScroll:'trimSnaps', dragFree:false}, opts||{})); }
    catch(e){ host.__emblaDone=false; return; }
    host.__embla=embla;
    var dots=document.createElement('div'); dots.className='era-embla__dots';
    embla.scrollSnapList().forEach(function(_,i){ var b=document.createElement('button'); b.className='era-embla__dot'; b.setAttribute('aria-label','Go to slide '+(i+1)); b.addEventListener('click',function(){embla.scrollTo(i);}); dots.appendChild(b); });
    host.appendChild(dots);
    var dEls=[].slice.call(dots.children);
    function sel(){ var i=embla.selectedScrollSnap(); dEls.forEach(function(d,k){ d.classList.toggle('is-on',k===i); }); }
    embla.on('select',sel); embla.on('reInit',sel); sel();
    embla.reInit();
  }
  function transformComparison(){
    var anyRow=document.querySelector('.feature-row');
    if (!anyRow) return;
    var table=anyRow.closest('table'); if (!table || table.__emblaDone) return;
    var titles=[].slice.call(table.querySelectorAll('.comparison-product-title')).map(function(t){return t.textContent.trim();});
    if (titles.length<2) titles=['Healed by the Ocean','Other creams'];
    var rows=[].slice.call(table.querySelectorAll('.feature-row'));
    if (rows.length<2) return;
    var cards=rows.map(function(r){
      var fc=r.querySelector('.feature-cell'); var name=fc?fc.textContent.trim():'';
      var vals=[].slice.call(r.querySelectorAll('.value-cell'));
      var card=document.createElement('div'); card.className='era-cmp-card';
      var h=document.createElement('div'); h.className='era-cmp-card__feat'; h.textContent=name; card.appendChild(h);
      var grid=document.createElement('div'); grid.className='era-cmp-card__grid';
      vals.slice(0,2).forEach(function(v,i){
        var col=document.createElement('div'); col.className='era-cmp-card__col'+(i===0?' is-hero':'');
        var icon=document.createElement('div'); icon.className='era-cmp-card__icon';
        var origSvg=v.querySelector('svg');
        var origColor = origSvg ? getComputedStyle(origSvg).color : '';
        icon.innerHTML=v.innerHTML;
        // column 0 = hero (Healed by the Ocean) = green check ; column 1 = green/red from original or red x
        var dark = !origColor || origColor==='rgb(38, 36, 29)' || origColor==='rgb(0, 0, 0)' || origColor==='rgb(51, 51, 51)';
        var c = dark ? (i===0 ? '#16a34a' : '#d14343') : origColor;
        icon.style.color=c; var ns=icon.querySelector('svg'); if(ns){ ns.style.color=c; ns.style.fill='currentColor'; }
        var lbl=document.createElement('div'); lbl.className='era-cmp-card__lbl'; lbl.textContent=titles[i]||'';
        col.appendChild(icon); col.appendChild(lbl); grid.appendChild(col);
      });
      card.appendChild(grid); return card;
    });
    table.__emblaDone=true;
    var host=document.createElement('div'); host.className='era-cmp-host';
    cards.forEach(function(c){ host.appendChild(c); });
    table.style.display='none';
    table.parentNode.insertBefore(host, table.nextSibling);
    build(host, cards, {loop:true, align:'center'});
  }
  function run(){
    if (!ready()) return;
    injectCss();
    try {
      var ing=document.querySelector('.tb-ingredients-section');
      if (ing){
        var cards=[].slice.call(ing.querySelectorAll('.tb-ing__card'));
        if (cards.length>=2){ var parent=cards[0].parentNode; build(parent, cards, {loop:true, align:'center'}); }
      }
    } catch(e){}
    try { transformComparison(); } catch(e){}
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', function(){ setTimeout(run,80); });
})();
